import { PlantDto } from '@trucktrax/trucktrax-ts-common';
import { SET_CURRENT_PLANT, SET_INCOMING_PLANT_LIST } from '../../constants/actionConstants';

export const setCurrentPlant = (value?: PlantDto) => ({
  type: SET_CURRENT_PLANT,
  payload: value ?? null,
});

export const setIncomingPlantList = (plants: PlantDto[]) => ({
  type: SET_INCOMING_PLANT_LIST,
  payload: plants,
});
